import { render, staticRenderFns } from "./index.vue?vue&type=template&id=12394cac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12394cac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12394cac')) {
      api.createRecord('12394cac', component.options)
    } else {
      api.reload('12394cac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=12394cac&scoped=true", function () {
      api.rerender('12394cac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/contact-hold/index.vue"
export default component.exports